const emotionCacheProps = {
  key: "css",
  prepend: true,
};

export default emotionCacheProps;
